import { combineReducers } from 'redux'
import { createResponsiveStateReducer } from 'redux-responsive'
import { LOCATION_CHANGE } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import { breakpointsJs } from 'styles/breakpoints'
import apolloClient from './apollo'

const initialState = {
  locationBeforeTransitions: null
}

const apolloReducer = apolloClient.reducer()
const responsiveStateReducer = createResponsiveStateReducer(breakpointsJs)

const routerReducer = (state = initialState, action) => {
  if (action.type === LOCATION_CHANGE) {
    return { ...state, locationBeforeTransitions: action.payload }
  }
  return state
}

/**
 * Expose global reducers and provide a hook to add asynchronously loaded ones
 * @param asyncReducers
 * @returns {function} rootReducer
 */
export default function (asyncReducers = {}) {
  return combineReducers({
    apollo: apolloReducer,
    browser: responsiveStateReducer,
    routing: routerReducer,
    form: formReducer,
    ...asyncReducers
  })
}
